import { render } from "./ComplianceDocuments.vue?vue&type=template&id=48785fde&scoped=true"
import script from "./ComplianceDocuments.vue?vue&type=script&lang=js"
export * from "./ComplianceDocuments.vue?vue&type=script&lang=js"

import "./ComplianceDocuments.vue?vue&type=style&index=0&id=48785fde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48785fde"]])

export default __exports__